<div class="container">
  <div class="row">
    <div class="col-3 p-0 d-flex align-items-center">
      <div class="progress mt-3 mb-3 ">
        <div class="progress-bar twenty-percent" [ngStyle]="{'width': (roteiro.totalClienteEntregue / roteiro.totalCliente) * 100 + '%' }"></div>
      </div> <span class="ms-2 me-4 info-porcentagem"> {{ ((roteiro.totalClienteEntregue / roteiro.totalCliente) * 100).toFixed(0) + '%' }}
      </span>
      
    </div>
    <div class="col-9 p-0">
      <div class="container">
        <div class="row">
          <div class="col-3 p-0" *ngFor="let status of informacoesStatus">
            <p class="titulo mb-0">{{ status.titulo }}</p>
            <p class="sub-titulo">{{ status.valor }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>   